import { fetchAndActivate, getValue } from "firebase/remote-config";

import { remoteConfig } from "../firebase/firebase";
import {
  AMPLITUDE_API_KEY,
  AMPLITUDE_IDENTIFY_URL,
  RemoteConfig,
} from "./constants";
import { IUserProperties } from "./models";

export const ampliIncrementEvent = async (
  userId: string,
  userProperty: IUserProperties
) => {
  await fetchAndActivate(remoteConfig);
  const amplitudeApiKey = getValue(
    remoteConfig,
    AMPLITUDE_API_KEY
  ) as unknown as RemoteConfig;
  fetch(
    `${AMPLITUDE_IDENTIFY_URL}?api_key=${amplitudeApiKey?._value}&identification=[{"user_id":${userId}, "user_properties":{"$add":{${userProperty}:1}}}]`,
    {
      method: "POST",
      redirect: "follow",
    }
  )
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.log("error", error));
};
